import { Component, Input } from '@angular/core';
import { AuditInfo } from 'src/app/models/general/audit-info.model';

@Component({
  selector: 'app-audit-line',
  templateUrl: './audit-line.component.html',
  styleUrl: './audit-line.component.scss'
})
export class AuditLineComponent {

  @Input()
  public data: AuditInfo;
}
